// extracted by mini-css-extract-plugin
module.exports = {"disable-scroll":"stepper_disable-scroll__1V0Gf"};